module.exports = __webpack_public_path__ + "img/2.93436f1d.png";